import type { RequestSpec } from '@/types';

export function generateGo(url: string, spec: RequestSpec, hasAuth: boolean): string {
  const hasBody = spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE';

  const bodySection = hasBody
    ? `\tpayload := []byte(\`${JSON.stringify(spec.body, null, 2).replace(/`/g, '\\`')}\`)
\treq, err := http.NewRequest("${spec.method}", url, bytes.NewBuffer(payload))`
    : `\treq, err := http.NewRequest("${spec.method}", url, nil)`;

  return `package main

import (
\t"bytes"
\t"fmt"
\t"io"
\t"net/http"
\t"os"
)

func main() {
\turl := "${url}"
\taccessToken := os.Getenv("LIBERTIFY_TOKEN")
${bodySection}
\tif err != nil {
\t\tpanic(err)
\t}
\treq.Header.Set("Accept", "application/json")
${hasAuth ? '\treq.Header.Set("Authorization", "Bearer "+accessToken)\n' : ''}${hasBody ? '\treq.Header.Set("Content-Type", "application/json")\n' : ''}
\tresp, err := http.DefaultClient.Do(req)
\tif err != nil {
\t\tpanic(err)
\t}
\tdefer resp.Body.Close()

\tbody, _ := io.ReadAll(resp.Body)
\tfmt.Println(resp.Status)
\tfmt.Println(string(body))
}
`;
}
